import { Radio, RadioProps } from '@mui/material'
import { styled } from '@mui/material/styles'

const Icon = styled('span')<any>(() => ({
  width: '20px',
  height: '20px',
  borderRadius: '20px',
  border: '1px solid #7B849D',
  margin: '2px',
  boxSizing: 'border-box'
}))

const CheckedIcon = styled('span')<any>(({ theme }) => ({
  width: '20px',
  height: '20px',
  borderRadius: '20px',
  border: `1px solid ${theme.palette.secondary.main}`,
  backgroundColor: '#ffffff',
  boxSizing: 'border-box',
  margin: '2px',
  position: 'relative'
}))

const CheckedIconCircle = styled('span')<any>(({ theme }) => ({
  position: 'absolute',
  display: 'block',
  top: '3px',
  left: '3px',
  width: '12px',
  height: '12px',
  backgroundColor: theme.palette.secondary.main,
  borderRadius: '12px'
}))

const BelugaRadio = (props: RadioProps): JSX.Element => {
  return (
    <Radio
      icon={<Icon />}
      checkedIcon={
        <CheckedIcon>
          <CheckedIconCircle />
        </CheckedIcon>
      }
      {...props}
    />
  )
}

export default BelugaRadio
